/* @flow */

export const noBorder = Symbol();
